<template>
    <div class="div-externa justify-content-between">
        <Sidebar @toggleCheckbox="toggleCheckbox"/>
        <div class="content-master-page" :class=" checkbox ? `min-width` : ''" v-if="user">
            <div class="content-div-superior" :class="$route.name == 'Master Page' ? '': 'height-auto'">
                <div class="identify-content my-2">
                    <div id="img-logo">
                        <img src="@/assets/optum-logo.svg" width="290"/>
                    </div>
                    <div id="perfil"><a class="mr-3">{{user.name}}</a><DynamicIcon icon="avatar-img" classString="img-perfil"/></div>
                    <b-popover target="perfil" triggers="hover" placement="top" custom-class="popover-np">
                        <div class="popover-perfil">
                            <div class="popover-info">
                                <div class="img-perfil img-popover"></div>
                                <p class="name-perfil">{{user.name}}</p>
                                <!-- <p class="nivel-perfil">Administrador</p> -->
                                <!-- <p class="last-access-perfil">Último acesso: 01/01/2021 - 15:00</p> -->
                            </div>
                            <div class="popover-btns">
                                <!-- <b-button class="btn-base btn-back-initial">MEU PERFIL</b-button> -->
							<b-button pill class="btn-base primary-btn" @click="logout">Sair</b-button>
                            </div>
                        </div>
                    </b-popover>
                </div>
                <div class="title-seja-bemvindo d-flex w-100 my-1 optum-bold" v-if="$route.name == 'Master Page'">
                    Seja bem-vindo(a) à Optum
                </div>
            </div>
            <div class="content-div-inferior">
                <div class="content-subdiv-inferior">
                    
                    <b-modal id="modal-edit-cpf-or-phone" centered body-class="modal-video-importacao body-class container" size="md" no-close-on-backdrop no-close-on-esc
                    hide-header-close v-if="!isAdmin">
                        <template #modal-title>
                            <DynamicIcon icon="head-brain" classString="container-modal-title-icon mr-2"/>
                            <h4 class="optum-bold mb-1 col-md-12">Complete seu cadastro</h4>
                        </template>
                        <p class="text-muted mb-4">Por favor, informe seus dados para continuar.</p>
                        <div class="col-md-12 d-flex flex-column align-items-center">
                            <b-form-group label="CPF" label-for="cpfUsuario" class="col-12 col-md-6 px-1">
                                <b-form-input id="cpfUsuario" placeholder="000.000.000-00" :state="state.cpf" v-model="form.cpf" v-mask="['###.###.###-##']" :disabled="isEmpty.cpf == false" />
                                <b-form-invalid-feedback :state="state.cpf">{{validateMessage.cpf}}</b-form-invalid-feedback>
                            </b-form-group>

                            <b-form-group label="Celular" label-for="phoneUsuario" class="col-12 col-md-6 px-1">
                                <b-form-input id="phoneUsuario" placeholder="(99) 99999-9999" :state="state.phone" v-model="form.phone" v-mask="['(##) #####-####']" :disabled="isEmpty.phone == false"/>
                                <b-form-invalid-feedback :state="state.phone">{{validateMessage.phone}}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                          <template #modal-footer>
                            <b-button pill class="btn-base primary-btn" @click="request">Salvar</b-button>
                        </template>	
                    </b-modal>

                    <router-view/>
                </div>
                <p class="px-4 mt-2">© {{ new Date().getFullYear() }} Optum, Inc. Todos os direitos reservados.</p>
            </div>
        </div>
    </div>
</template>

<script>
import Sidebar from "./components/Sidebar"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import { mapActions, mapGetters } from "vuex"
import UserResource from '@/resources/UserResource.js'
import Validations from "@/util/Validations"

export default {
    name: "MasterPage",
    components: {
        Sidebar,
        DynamicIcon
    },
    data(){
        return {
            checkbox: true,
            form : { cpf: "", phone: ""},
            isEmpty : { cpf: "", phone: ""},
            validateMessage: {
                cpf: null,
                phone: null,
            }
        }
    },
    computed: {
        ...mapGetters("user", ["user", "authorities"]),
        state() {
            return {
                cpf: this.validateMessage.cpf ? false : null,
                phone: this.validateMessage.phone ? false : null,
            }
        },
        isAdmin () {
            if ( this.authorities ) {
                return this.authorities.includes("ROLE_ADMIN")
            }   
            return false;
        }
    },
    methods: {
        ...mapActions("user", ["loadUserInfo", "clearLoggedUser"]),
        logout() {
            this.clearLoggedUser()
            .then(() => {
                this.$router.replace('/')
            })
        },
        toggleCheckbox( value ){
            this.checkbox = value
        },
        request() {

            this.validateMessage.phone = Validations.cellPhone( this.form.phone, true, true)                 
            this.validateMessage.cpf = Validations.cpf( this.form.cpf, true)

            if(Validations.isEmpty( this.validateMessage ))   
            {
                UserResource.updateUser(this.form, {showLoader: true})
                .then(() => {
                    this.$bvModal.hide('modal-edit-cpf-or-phone')
                });

            }
        }
    },
    created() {
        if (!this.user)
        {
            this.loadUserInfo()
        }

    },
    mounted() {
        
        UserResource.infoUpdate({showLoader: true})
        .then(userInfo => {

           this.form.cpf = userInfo.cpf
           this.form.phone = userInfo.phone

           if(!this.form.cpf || !this.form.phone)
           {

            this.isEmpty = {
                cpf: !this.form.cpf,
                phone: !this.form.phone
            }

            console.log('abrir modal')
            this.$bvModal.show('modal-edit-cpf-or-phone')
           }
        })
    }
}
</script>

<style scoped lang="scss">
.div-externa{
    display: flex;
}

.content-master-page{
   /* background-color: #EFEFEE; */
    width: calc(100% - 60px);
    min-height: 100vh;
    transition: 0.3s;
    height: 100%;
}

@media (max-width: 930px) {
    html body .content-master-page,html body .content-master-page.min-width{
        width: 100% ;
    }
}

.content-master-page.min-width{
    width: calc(100% - 260px);
}

.content-div-superior{
    background-color: #FBF9F4;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 130px;
    width: 100%;
    padding: 0px 2%;
}

.identify-content{
    width: 100%;
    height: 57px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.identify-content > b {
    font-size: 20px;
}

.height-auto {
    height: auto !important;
}

.div-breadcrumb{
    padding-top: 15px;
    width: 100%;
}

.content-subdiv-inferior{
    min-height: 85vh;
    border-radius: 10px;
}

.content-div-inferior p{
    margin: 0;
    width: 100%;
    text-align: initial;
    font-size: 14px;
}

#perfil{
    display: flex;
    align-items: center;
}

html body .img-perfil{
    width: 40px;
    height: 40px;
    margin-bottom: 0px !important;
    margin-right: 10px;
}

#perfil a{
    color: #002677;
    font-weight: 600;
}

#perfil a:hover{
    color: #F2B411 !important;
    cursor: pointer;
}

/* POPOVER */
p{
    margin: 0px;  
}

.popover-perfil{
    width: 230px;
    /* height: 213px; */
}

.popover-info{
    width: 100%;
    height: calc(100% - 63px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
}

.img-perfil.img-popover{
    width: 64px;
    height: 64px;
    border-radius: 32px;
    margin: 0px;
}

.name-perfil{
    font-size: 16px;
    font-weight: 600;
    color: #002677;
    text-align: center;
    margin-top: 8px;
    margin-bottom: 20px;
}

.nivel-perfil{
    font-size: 14px;
    color: #002677;
}

.last-access-perfil{
    margin: 20px 0px;
    font-size: 12px;
    color: #002677;
}

.popover-btns{
    border-top: 2px solid #002677 !important;
    height: 63px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.title-seja-bemvindo{
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 24px;
    color: $primaryColor;
    text-align: initial;
}

@media (max-width: 930px) {
    .div-externa{
        flex-direction: column;
        height: auto;
    }

    .div-breadcrumb{
        display: none;
    }


    .content-div-superior{
        height: 60px;
        padding: 0px 15px;
    }

    #perfil a{
        display: none;
    }

    .img-perfil{
        margin: 0px;
    }
    
    .content-subdiv-inferior{
        transform: none;
        width: 100%;
        height: 100%;
    }

    .content-div-inferior{
        height: calc(100% - 60px);
        padding: 0px;
    }

    .content-div-inferior p{
        display: none;
    }
}
.popover-body {
    padding: 0px !important;
}

#img-logo {
    width: 290px;
}

@media (max-width: 770px) {
    #img-logo {
        display: none;
    }
}

#modal-edit-cpf-or-phone h4 {
  color: #002677;
  font-weight: 700;
}

#modal-edit-cpf-or-phone p {
  font-size: 14px;
  color: #555;
}

</style>